import { useMemo } from "react";
import { useSearchQuery, useSearchResult, useSearchStatus } from "hooks";
import { searchService } from "services";

const useSearch = (abort = true) => {
  const [query, setQuery] = useSearchQuery(abort);
  const [result, setResult] = useSearchResult();
  const [status, setStatus] = useSearchStatus();
  const actions = useMemo(
    () => ({
      execute: searchService.execute,
      reset: searchService.reset,
      abort: searchService.abort,
    }),
    []
  );
  return {
    query,
    setQuery,
    result,
    setResult,
    status,
    setStatus,
    actions,
  };
};

export { useSearch };
